import React, { useEffect, useRef, useState } from "react";
// slider
import Slider from "react-infinite-logo-slider";

// Images and Icons
import AnchorRightIcon from "assets/breakfast-event/svgs/anchor-right.svg";
import Vector from "assets/breakfast-event/svgs/vector.svg";
import CloseIcon from "assets/breakfast-event/svgs/close-circle.svg";
import AddCircleIcon from "assets/breakfast-event/svgs/add-circle.svg";
import SnapshotIcon from "assets/breakfast-event/svgs/snapshot.svg";
import CircularBg from "assets/breakfast-event/svgs/crcular-bg.svg";
import BackgroundImage from "assets/breakfast-event/png-jpg/awards-bg.png";
import AwardIcon from "assets/breakfast-event/svgs/award.svg";
import AwardOverlayBg from "assets/breakfast-event/png-jpg/award-overlay-bg.png";
import AwardImage from "assets/breakfast-event/png-jpg/award.png";
import AwardSliderImage from "assets/breakfast-event/png-jpg/award-slider-image.png";
import SmartcomplyTechcalalBgImage from "assets/breakfast-event/png-jpg/smartcomply-techcabal-bg.png";
import DesktopResearchImage from "assets/breakfast-event/png-jpg/desktop-research.png";

import {
  AWARDS_ENGLISH,
  AWARDS_FRENCH,
  FAQS_ENGLISH,
  FAQS_FRENCH,
  LATEST_GALLERY,
} from "./utils/constants";
import Pagination from "./components/Pagination";

// Translations
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Faq = () => {
  // Translations
  const { t } = useTranslation("event");
  const language = localStorage.getItem("selectedLanguage");

  const [show, setShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const containerRef = useRef(null);
  const containerRef1 = useRef(null);

  const FAQS = language?.includes("fr") ? FAQS_FRENCH : FAQS_ENGLISH;

  const AWARDS = language?.includes("fr") ? AWARDS_FRENCH : AWARDS_ENGLISH;

  // Functions
  const toggle = (index) => {
    if (show === index) {
      return setShow(null);
    }
    return setShow(index);
  };

  const handleRegister = () => {
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLScNFWGjiRVGtoU6NNRG4iw1ZRQ2i_dRHUkI8XfNev4F__aKcg/viewform?usp=publish-editor",
      "_blank",
    );
  };
  useEffect(() => {
    if (!isOpen) return;

    const handleKey = (e) => {
      if (e.key === "ArrowRight") {
        setCurrentIndex((i) => (i === LATEST_GALLERY.length - 1 ? 0 : i + 1));
      }
      if (e.key === "ArrowLeft") {
        setCurrentIndex((i) => (i === 0 ? LATEST_GALLERY.length - 1 : i - 1));
      }
      if (e.key === "Escape") setIsOpen(false);
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen1) return;

    const handleKey = (e) => {
      if (e.key === "ArrowRight") {
        setCurrentIndex((i) => (i === AWARDS.length - 1 ? 0 : i + 1));
      }
      if (e.key === "ArrowLeft") {
        setCurrentIndex((i) => (i === 0 ? AWARDS.length - 1 : i - 1));
      }
      if (e.key === "Escape") setIsOpen1(false);
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen1, AWARDS.length]);
  return (
    <div className="flex justify-center items-center flex-col font-euclid w-[100%]">
      <div className="bg-[#FFF4E3] h-full text-white w-full">
        <div className="bg-[#4D61B0]">
          <div
            className="h-[40px] flex items-center  overflow-hidden  bg-cover bg-center"
            style={{ backgroundImage: `url(${AwardSliderImage})` }}
          >
            <div className="w-full overflow-hidden">
              <div className="block md:hidden">
                <Slider
                  width="100vw"
                  duration={120}
                  pauseOnHover={false}
                  blurBorders={false}
                  blurBorderColor={"#fff"}
                >
                  {Array(10)
                    .fill(t("agenda.mixerSlide"))
                    .flat()
                    .map((item, index) => (
                      <Slider.Slide key={index}>
                        <div className="px-4 md:px-8 flex items-center">
                          <p className="text-[#202D66] font-euclid text-[14px] md:text-[20px] font-semibold whitespace-normal">
                            {item}
                          </p>
                        </div>
                      </Slider.Slide>
                    ))}
                </Slider>
              </div>
              <div className="hidden md:block xl:hidden">
                <Slider
                  width="50vw"
                  duration={120}
                  pauseOnHover={false}
                  blurBorders={false}
                  blurBorderColor={"#fff"}
                >
                  {Array(10)
                    .fill(t("agenda.mixerSlide"))
                    .flat()
                    .map((item, index) => (
                      <Slider.Slide key={index}>
                        <div className="px-4 md:px-8 flex items-center">
                          <p className="text-[#202D66] font-euclid text-[14px] md:text-[20px] font-semibold whitespace-normal">
                            {item}
                          </p>
                        </div>
                      </Slider.Slide>
                    ))}
                </Slider>
              </div>
              <div className="hidden xl:block">
                <Slider
                  width="40vw"
                  duration={120}
                  pauseOnHover={false}
                  blurBorders={false}
                  blurBorderColor={"#fff"}
                >
                  {Array(10)
                    .fill(t("agenda.mixerSlide"))
                    .flat()
                    .map((item, index) => (
                      <Slider.Slide key={index}>
                        <div className="px-4 md:px-8 flex items-center">
                          <p className="text-[#202D66] font-euclid text-[14px] md:text-[20px] font-semibold whitespace-normal">
                            {item}
                          </p>
                        </div>
                      </Slider.Slide>
                    ))}
                </Slider>
              </div>
            </div>
          </div>
          <div className="py-[3rem] relative">
            <div className="flex justify-between items-start flex-col md:flex-row relative">
              <div className="md:w-[60%] mx-[1rem] md:mx-[3.5rem] mt-[2rem]">
                <h1 className="text-3xl md:text-[40px] font-euclidSemibold">
                  {t("agenda.mixerTitle")}
                </h1>
                <p className="text-lg mt-3 w-full md:w-[550px] font-euclidRegular">
                  {t("agenda.mixerDescription")}
                </p>
                <div className="flex items-center mt-10">
                  <button
                    className="bg-[#202D66] text-white text-base font-euclidSemibold h-[48px] px-5 rounded-l-[16px] rounded-r-none"
                    onClick={handleRegister}
                  >
                    {t("agenda.mixerCta")}
                  </button>
                  <button className="bg-[#AFF7CD] text-white text-base font-semibold h-[48px] px-5 rounded-r-[16px] rounded-l-none flex items-center justify-center">
                    <img src={AnchorRightIcon} alt="AnchorRightIcon" />
                  </button>
                </div>
              </div>
              <div className="absolute top-[-14%] !right-0 hidden md:block">
                <img src={Vector} alt="Vector" />
              </div>
              <div className="absolute bottom-0 right-[15%] md:right-[25%] md:bottom-[-20%] xl:right-[30%] xl:bottom-0 hidden md:block">
                <img
                  src={AwardImage}
                  alt="AwardImage"
                  className="w-[89px] h-[250px]"
                />
              </div>
            </div>
            <div className="mt-[3rem] md:mt-[5rem] pl-[1rem] md:pl-[3.5rem]">
              <h1 className="text-[24px] text-white font-euclidSemibold">
                {t("agenda.award")}
              </h1>
              <div className="w-full relative mt-[1rem] md:mt-[2rem]">
                <div
                  ref={containerRef1}
                  className="overflow-x-auto scroll-smooth no-scrollbar overflow-y-hidden"
                >
                  <div className="flex gap-5">
                    {AWARDS.map((option, index) => (
                      <div
                        key={index}
                        className="group shrink-0 w-[300px] h-[350px] md:w-[354px] md:h-[352px] rounded-lg relative bg-cover bg-center flex justify-center items-center flex-col gap-2 px-4"
                        style={{ backgroundImage: `url(${BackgroundImage})` }}
                      >
                        <div className=" gap-2 px-4 text-left space-y-3">
                          <img src={AwardIcon} alt="AwardIcon" />
                          <h4 className="text-[#334155] text-[20px] md:text-[24px] font-euclidSemibold w-[60%]">
                            {option.title}
                          </h4>
                          <p className="text-[#475569] text-base md:text-lg font-euclidMedium text-left">
                            {option.eligibility}
                          </p>
                        </div>
                        {/* Hover Overlay */}
                        <div
                          className="
                              w-[354px] h-[352px]
                              bg-cover bg-center
                              absolute top-0 left-2
                              py-8 px-4

                              opacity-0
                              translate-y-6
                              group-hover:opacity-100
                              group-hover:translate-y-0

                              transition-all
                              duration-500
                              ease-out
                            "
                          style={{ backgroundImage: `url(${AwardOverlayBg})` }}
                        >
                          <div className="w-[80%] space-y-3">
                            <h4 className="text-[15px] text-[#334155] font-semibold">
                              Description
                            </h4>
                            <p className="text-[#334155] text-[15px] font-normal">
                              {option.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Pagination */}
                <div className="flex justify-left items-center mt-[2rem]">
                  <Pagination containerRef={containerRef1} type="speakers" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="my-[3rem] py-7 flex justify-center items-center flex-col">
          <div className="flex justify-center items-center">
            <div
              className="w-[92%] h-[587px] overflow-hidden  bg-cover bg-center relative"
              style={{ backgroundImage: `url(${SmartcomplyTechcalalBgImage})` }}
            >
              <img
                src={DesktopResearchImage}
                alt="DesktopResearchImage"
                className="absolute right-5 md:right-10 top-5 w-[250px] h-[24px md:w-[315px] md:h-[33px]"
              />
              <div className="py-[4rem] px-[1rem] md:p-[5rem] font-bebas">
                <div className="space-y-5">
                  <h1 className="text-xl md:text-[36px] uppercase md:w-[65%] leading-[40px] font-bebas">
                    {t("faq.ai_title")}
                  </h1>
                  <p className="md:w-[65%] text-base font-euclidRegular">
                    {t("faq.ai_description")}
                  </p>
                  <div className="flex items-center">
                    <Link to="/desktop-research">
                      <div className="flex items-center">
                        <button className="bg-[#202D66] font-euclidSemibold text-white text-base xl:text-base font-semibold h-[48px] px-6 md:px-5 rounded-l-[16px] rounded-r-none">
                          {t("learnMore")}
                        </button>
                        <button className="bg-[#AFF7CD] text-white text-base font-semibold h-[48px] px-5 rounded-r-[16px] rounded-l-none flex items-center justify-center">
                          <img src={AnchorRightIcon} alt="AnchorRightIcon" />
                        </button>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center my-[5rem]">
            <div className="w-[92%] flex justify-between items-start flex-col md:flex-row gap-5">
              <div>
                <h1 className="text-[#334155] text-4xl md:text-[64px] font-euclidSemibold">
                  {t("faq.title")}
                </h1>
                <p className="text-[#334155] text-base md:text-lg font-euclidRegular mt-3 md:w-[70%]">
                  {t("faq.description")}
                </p>
              </div>
              <div className="flex items-center justify-end w-full">
                <div className="mx-auto flex flex-col items-center justify-center ">
                  {FAQS?.map((faq, index) => {
                    return (
                      <div key={index} className="w-full py-2">
                        <div
                          onClick={() => toggle(index)}
                          className="pr-4 border-b border-[#95D2AE] cursor-pointer"
                        >
                          <div className="flex items-center justify-between pt-2 pb-3.5">
                            <p className="text-base font-euclidMedium md:text-xl text-[#334155]">
                              {faq.question}
                            </p>
                            <div>
                              <img
                                src={show === index ? CloseIcon : AddCircleIcon}
                                className={`${
                                  show === index ? "" : "rotate-180"
                                } transition-transform duration-700`}
                                alt=""
                              />
                            </div>
                          </div>
                          <div
                            className={`overflow-hidden transition-all duration-1000 ${
                              show === index ? "max-h-[500px]" : "max-h-0"
                            }`}
                          >
                            <p className="text-[#475569] text-sm md:text-base font-euclidRegular max-w-lg mb-3">
                              {faq.answer}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center flex-col text-[#334155] gap-1 w-[92%] text-center">
          <div className="bg-[#FFC87F33] bg-opacity-20 rounded-full px-3 py-1 w-fit">
            <p className="text-base font-euclidMedium text-center text-[#334155]">
              {t("faq.previousEvent.tag")}
            </p>
          </div>
          <div className="flex justify-center items-center">
            <div className="text-[#1E293B] flex justify-center items-center flex-col md:flex-row gap-1 text-[36px] md:text-[40px] xl:text-[48px] font-euclidSemibold">
              <h1>{t("faq.previousEvent.title1")}</h1>
              <img src={SnapshotIcon} alt="SnapshotIcon" />
              <h1>{t("faq.previousEvent.title2")}</h1>
            </div>
          </div>
          <p className="text-base md:text-lg font-euclidRegular text-center w-full md:w-[70%]">
            {t("faq.previousEvent.description")}
          </p>
        </div>
        <div className="w-full relative mb-10">
          <div
            ref={containerRef}
            className="mt-[3rem] overflow-x-auto scroll-smooth no-scrollbar"
          >
            <div className="flex gap-5 pl-[3.5rem]">
              {LATEST_GALLERY.map((pillar, index) => (
                <div
                  key={index}
                  className="group shrink-0 relative w-[300px] h-[350px] md:w-[355px] md:h-[359px] rounded-lg cursor-pointer"
                  onClick={() => {
                    setCurrentIndex(index);
                    setIsOpen(true);
                  }}
                >
                  {/* Card Image */}
                  <img
                    src={pillar}
                    alt={`Pillar ${index + 1}`}
                    className="w-full h-full rounded-lg shadow-md object-cover"
                  />

                  {/* Full-card hover overlay */}
                  <div
                    className="
                  absolute inset-0
                  bg-black bg-opacity-40
                  opacity-0 group-hover:opacity-100
                  transition-opacity duration-500 ease-out
                  rounded-lg
                "
                  >
                    {/* Circular "View" overlay inside full overlay */}
                    <div
                      className="
                    w-[115px] h-[112px]
                    bg-cover bg-center
                    flex justify-center items-center
                    rounded-full
                    absolute top-[35%] left-[35%]
                  "
                      style={{ backgroundImage: `url(${CircularBg})` }}
                    >
                      <h4 className="text-[24px] text-[#1C295A] font-semibold">
                        View
                      </h4>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* Pagination */}
          <div className="flex justify-center items-center mt-[2rem]">
            <Pagination containerRef={containerRef} type="faq" />
          </div>
        </div>
        {isOpen && (
          <div
            className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center"
            onClick={() => setIsOpen(false)} // 👈 overlay click closes
          >
            {/* Close button */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(false);
              }}
              className="absolute top-6 right-6 text-white text-3xl"
            >
              &times;
            </button>

            {/* Previous */}
            <button
              onClick={(e) => {
                e.stopPropagation(); // 👈 prevents closing
                setCurrentIndex(
                  currentIndex === 0
                    ? LATEST_GALLERY.length - 1
                    : currentIndex - 1,
                );
              }}
              className="absolute left-4 md:left-10 text-white text-4xl"
            >
              &#10094;
            </button>

            {/* Image */}
            <img
              src={LATEST_GALLERY[currentIndex]}
              alt="Gallery"
              onClick={(e) => e.stopPropagation()} // 👈 prevents closing
              className="max-w-[90%] max-h-[90%] rounded-lg object-contain"
            />

            {/* Next */}
            <button
              onClick={(e) => {
                e.stopPropagation(); // 👈 prevents closing
                setCurrentIndex(
                  currentIndex === LATEST_GALLERY.length - 1
                    ? 0
                    : currentIndex + 1,
                );
              }}
              className="absolute right-4 md:right-10 text-white text-4xl"
            >
              &#10095;
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Faq;
